<template>
  <header class="l-header">
    <app-header-bar />
    <app-header-nav />
  </header>
</template>

<script>
import { EventBus } from "src/event-bus.js";
import { currentLocal } from "src/i18n";

import AppHeaderBar from "components/AppHeader/AppHeaderBar/AppHeaderBar";
import AppHeaderNav from "components/AppHeader/AppHeaderNav/AppHeaderNav";

export default {
  name: "Header",
  components: {
    AppHeaderBar,
    AppHeaderNav
  },
  computed: {},
  methods: {
    setLocal(local) {
      const newUrl = window.location.href.replace(`/${currentLocal.lang}/`, `/${local}/`);

      EventBus.$emit("loader-cover-all", () => {
        window.location.href = newUrl;
      });
    }
  }
};
</script>

<style lang="scss">
/*==============================
=            Header            =
==============================*/

.l-header {
  z-index: 100;
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  color: $color-dark;

  @media #{$breakpoint-horizontal} {
    position: fixed;
    left: 0px;
    top: 0px;

    height: vh(100);
    width: var(--header-size);
  }
}
</style>
